import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {Component, Input, OnInit} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Store } from "../../../../services/store.service";
import {TranslatedBaseError} from "../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {ComponentValidationControllerService} from "../../../../services/form-controller/component-validation-controller.service";
import {ComponentValidation} from "../../../../models/component-validation";
import {BlacklistRow} from "../../../../models/blacklist-row";

@Component({
  selector: "validation-blacklist",
  templateUrl: "./blacklist.component.html",
  styles: [],
  providers: [],
})
export class ValidationBlacklistComponent extends TranslatedBaseError implements OnInit {

  @Input() public serviceId: string;
  @Input() public componentValidationId: string;
  @Input() public componentKey: string;

  public dynamicValidation: ComponentValidation = new ComponentValidation();
  public newRow: BlacklistRow = new BlacklistRow();
  public selectedRow: BlacklistRow = new BlacklistRow();
  public selectedIndex: number;

  constructor(private componentValidationControllerService: ComponentValidationControllerService,
              public store: Store,
              toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit(): void {
    this.load();
  }

  public dropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.save();
    }
  }

  public fixIndexes() {
    this.dynamicValidation.blacklistRows.forEach((it, index) => {
      it.sortOrder = index;
    });
  }

  public addNewRow(): void {
    if (!this.dynamicValidation) {
      this.dynamicValidation = new ComponentValidation();
    }
    const copy: BlacklistRow = JSON.parse(JSON.stringify(this.newRow));
    this.dynamicValidation.blacklistRows.push(copy);
    this.newRow = new BlacklistRow();
    this.save();
  }

  public isAddButtonDisabled(): boolean {
    return !this.newRow.value;
  }

  public createNewRow() {
    this.selectedRow = new BlacklistRow();
    this.dynamicValidation.blacklistRows.push(this.selectedRow);
  }

  public closeEdit() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }

  public isDeterminantEmpty(jsonDeterminant: string): boolean {
    if (jsonDeterminant) {
      const dets = JSON.parse(jsonDeterminant)[0].items;
      return !(dets && dets.length > 0);
    }
    return true;
  }

  private load() {
    const cb = (data) => {
      this.dynamicValidation = data || new ComponentValidation();
      if (!this.dynamicValidation.blacklistRows?.length) { this.dynamicValidation.blacklistRows = []; }
      this.dynamicValidation.blacklistRows.sort((a, b) => a.sortOrder - b.sortOrder);
    };
    if (this.componentValidationId) {
      this.componentValidationControllerService.getById(this.componentValidationId).subscribe(
        cb, (error) => this.showErrorMessage(error));
    } else {
      this.componentValidationControllerService.get(this.serviceId, this.componentKey).subscribe(
        cb, (error) => this.showErrorMessage(error));
    }
  }

  private static sendSaveProcessingEvent(state = true) {
    window.top.postMessage([{channel: "FormBuilder", message: JSON.stringify({event: "saveProcessing", state})}], "*");
  }

  public disableSave() {
    ValidationBlacklistComponent.sendSaveProcessingEvent();
  }

  private sendMessage(): void {
    const message = {
      key: this.componentKey, count: this.dynamicValidation.blacklistRows.length,
      changes: {
        componentValidationId: this.dynamicValidation.id, blacklistRowIds: this.dynamicValidation.blacklistRows.map((a) => a.id),
      },
    };
    const messageString: string = JSON.stringify(message);
    window.top.postMessage([{channel: "FormBuilder", message: messageString}], "*");
  }

  public save() {
    ValidationBlacklistComponent.sendSaveProcessingEvent();
    this.fixIndexes();
    const cb = (data) => {
      data?.blacklistRows?.sort((a, b) => a.sortOrder - b.sortOrder);
      Object.assign(this.dynamicValidation, data);
      this.componentValidationId = this.dynamicValidation.id;
      this.responseSuccessful("Component updated!");
      this.sendMessage();
      ValidationBlacklistComponent.sendSaveProcessingEvent(false);
    };
    const errorCb = (error) => {
      this.showErrorMessage(error);
      ValidationBlacklistComponent.sendSaveProcessingEvent(false);
    };
    if (this.componentValidationId) {
      this.componentValidationControllerService.saveById(this.componentValidationId, this.dynamicValidation).subscribe(
        cb, errorCb,
      );
    } else {
      this.componentValidationControllerService.save(this.serviceId, this.componentKey, this.dynamicValidation).subscribe(
        cb, errorCb,
      );
    }

  }

  public deleteRow(index: number): void {
    if (index > -1) {
      this.dynamicValidation.blacklistRows.splice(index, 1);
      this.save();
    }
  }

  public exactMatchChanged(row: BlacklistRow): void {
    if (row.exactMatch) { row.wordMatch = false; }
  }
  public wordMatchChanged(row: BlacklistRow): void {
    if (row.wordMatch) { row.exactMatch = false; }
  }
}
